module.exports = __webpack_public_path__ + "static/img/wx.27a4e9a9.png";